import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CabinetService {
  layout: 'board' | 'table';

  constructor() {}
}
